/**
 * Velocidades de reproducción disponibles para los audios de aprendizaje.
 * Fuente única compartida por las conversaciones (SpeedDropdown en burbujas)
 * y el audio de historias (PlaybackSpeedDrawer desde la barra inferior):
 * ambas UIs deben ofrecer siempre las mismas opciones.
 */
export const AUDIO_SPEED_OPTIONS = [0.75, 1, 1.25] as const;
